import gql from 'graphql-tag';

export const MARK_CONTENT_REVIEW_COMPLETE = gql`
  mutation MarkContentReviewCompleteMutation($projectId: Int!, $contentReviewId: Float!, $shouldMarkComplete: Boolean!) {
    markedForCompletion: updateContentReviewCompletionOverride(projectId: $projectId, contentReviewId: $contentReviewId, shouldMarkComplete: $shouldMarkComplete)
  }
`;
